// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logo__logo___wZVc4 {
    cursor: pointer;

    display: flex;
    gap: var(--space-s);
    align-items: center;

    color: unset;
    text-decoration: none;

    & > .Logo__text___rDEk2 {
        display: flex;
        gap: var(--space-2xs);
        align-items: center;
    }
}

@media (width <= 100rem) {
    .Logo__logo___wZVc4 > .Logo__text___rDEk2 {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Logo/Logo.css"],"names":[],"mappings":"AAAA;IACI,eAAe;;IAEf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;IAEnB,YAAY;IACZ,qBAAqB;;IAErB;QACI,aAAa;QACb,qBAAqB;QACrB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".logo {\n    cursor: pointer;\n\n    display: flex;\n    gap: var(--space-s);\n    align-items: center;\n\n    color: unset;\n    text-decoration: none;\n\n    & > .text {\n        display: flex;\n        gap: var(--space-2xs);\n        align-items: center;\n    }\n}\n\n@media (width <= 100rem) {\n    .logo > .text {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `Logo__logo___wZVc4`,
	"text": `Logo__text___rDEk2`
};
export default ___CSS_LOADER_EXPORT___;
